import VisaModal from '@/models/Visa';

const GET_VISA_PROGRESS_INFO = 'GET_VISA_PROGRESS_INFO';

/**
 * 获取签证办理进度
 */
async function getVisaProgressInfo(tradeCode) {
  const payload = await new VisaModal().progressInfo(tradeCode);
  return {
    type: GET_VISA_PROGRESS_INFO,
    payload
  }
}

const ACTION_TYPES = {
  GET_VISA_PROGRESS_INFO,
};

const ACTION = {
  getVisaProgressInfo,
};

const VisaProgress = {
  ACTION_TYPES,
  ACTION
}

export default VisaProgress;